export const createOrUpdateByKey = <T extends object>(
  array?: T[] | null,
  key?: keyof T,
  value?: unknown,
  newItem?: T,
) => {
  if (!array || typeof key === 'undefined' || typeof newItem === 'undefined') {
    return array
  }

  const index = array.findIndex((item) => item[key] === value)
  if (index === -1) {
    return [...array, newItem]
  }

  return [...array.slice(0, index), newItem, ...array.slice(index + 1)]
}
